export var primaryColor = {
  primary: "#FF641B",
  secondary: "#9C9A9A",
};

export var textColor = {
  primary: "#FFFFFF",
  secondary: "#232529",
};

export var backgroundColor = {
  primary: "#FF641B",
  secondary: "#9C9A9A",
};

export var boxShadow = {
  primary: "0px 4px 15px 0px #00000040 inset",
  secondary: "0px 4px 40px 0px #00000080",
};

export var border = {
  primary: "1px solid #9C9A9AB2",
};

// Functions to update theme colors dynamically
export const setPrimaryColor = (newPrimaryColor) => {
  primaryColor = { ...primaryColor, ...newPrimaryColor };
};

export const setTextColor = (newTextColor) => {
  textColor = { ...textColor, ...newTextColor };
};

export const setBackgroundColor = (newBackgroundColor) => {
  backgroundColor = { ...backgroundColor, ...newBackgroundColor };
};

export const setBoxShadow = (newBoxShadow) => {
  boxShadow = { ...boxShadow, ...newBoxShadow };
};

export const setBorder = (newBorder) => {
  border = { ...border, ...newBorder };
};
